export const SAVE_TOKEN = "SAVE_TOKEN";
export const REMOVE_TOKEN = "REMOVE_TOKEN";

export const GET_ME = "GET_ME";
export const GET_ME_SUCCESS = "GET_ME_SUCCESS";
export const HIDE_LOADING = "PROFILE.HIDE_LOADING";
